// extracted by mini-css-extract-plugin
export var accordion = "_dh-0";
export var chevron = "_dh-3";
export var closed = "_dh-2";
export var content = "_dh-4";
export var open = "_dh-1";
export var rotate = "_dh-5";